<template>
    <div v-show="visible" class="global-preview-iframe">
        <h4 style="margin-left: 10px">商品详情预览</h4>
        <iframe
            ref="iframe"
            src="https://apptest.dljiujiu.top/#/pages/goods_detail/pcDetail"
            style="width: 100%; height: 100%; border: 1px solid #eee"
            @load="onLoad"
            @error="onError"
        ></iframe>
    </div>
</template>

<script>
import previewBus from "@/utils/previewBus";

export default {
    name: "GlobalPreviewIframe",
    data() {
        return {
            visible: false,
            ready: false,
            version: 0,
            lastPayload: null,
        };
    },
    mounted() {
        previewBus.$on("preview-open", this.onOpen);
        previewBus.$on("preview-close", this.onClose);
        previewBus.$on("preview-data", this.onData);
    },
    beforeDestroy() {
        previewBus.$off("preview-open", this.onOpen);
        previewBus.$off("preview-close", this.onClose);
        previewBus.$off("preview-data", this.onData);
    },
    methods: {
        onOpen() {
            // 只切换可见性，不重建 iframe
            this.visible = true;
            // 如果之前已经 ready，缓存数据会在 onData 时自动补发
            if (this.ready && this.lastPayload) {
                this.send(this.lastPayload);
            }
        },
        onClose() {
            // 只隐藏，不销毁，不留内存垃圾
            this.visible = false;
        },
        onData(payload) {
            this.lastPayload = payload;
            if (this.ready) {
                this.send(payload);
            }
        },
        onLoad() {
            this.ready = true;
            if (this.lastPayload) {
                this.send(this.lastPayload);
            }
        },
        onError() {
            this.ready = false;
            console.error("[PreviewIframe] 加载失败");
        },
        send(payload) {
            const iframe = this.$refs.iframe;
            if (!iframe || !iframe.contentWindow) return;
            this.version += 1;
            try {
                iframe.contentWindow.postMessage(
                    {
                        type: "PREVIEW_GOODS",
                        version: this.version,
                        data: payload,
                    },
                    "https://apptest.dljiujiu.top"
                );
            } catch (err) {
                console.error("[PreviewIframe] postMessage 失败", err);
            }
        },
    },
};
</script>

<style>
.global-preview-iframe {
    position: fixed;
    top: 80px;
    right: 10px;
    width: 430px;
    height: 720px;
    z-index: 9999;
}
</style>
